@if (planDocsTagHtml) {
  <div class='plan-docs-container'>
    <div [innerHTML]="planDocsTagHtml"></div>
  </div>
}